import IPlayerService from '../interfaces/playerService';

export default class HlsPlayerService implements IPlayerService {
  constructor(readonly videoElementRef: React.MutableRefObject<HTMLVideoElement | null>) { }

  public play = () => {
    if (this.videoElementRef.current) {
      this.videoElementRef.current.play();
    }
  }

  public pause = () => {
    if (this.videoElementRef.current) {
      this.videoElementRef.current.pause();
    }
  }

  public seek = (desiredSeektime: number) => {
    if (this.videoElementRef.current) {
      this.videoElementRef.current.currentTime = desiredSeektime;
    }
  }

  public mute = (isMuted: boolean) => {
    if (this.videoElementRef.current) {
      this.videoElementRef.current.muted = isMuted;
    }
  }

  public volume = (desiredVolumeLevel: number) => {
    if (this.videoElementRef.current) {
      const formatedDesiredVolumeLevel = desiredVolumeLevel * 0.01;
      this.videoElementRef.current.volume = formatedDesiredVolumeLevel;
    }
  }
}
